"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const PrismicProvider = require("./PrismicProvider.cjs");
const usePrismicContext = require("./usePrismicContext.cjs");
const usePrismicClient = require("./usePrismicClient.cjs");
const PrismicLink = require("./PrismicLink.cjs");
const PrismicText = require("./PrismicText.cjs");
const PrismicRichText = require("./PrismicRichText.cjs");
const prismicR = require("@prismicio/richtext");
const PrismicImage = require("./PrismicImage.cjs");
const SliceZone = require("./SliceZone.cjs");
const PrismicToolbar = require("./PrismicToolbar.cjs");
const usePrismicPreviewResolver = require("./usePrismicPreviewResolver.cjs");
const clientHooks = require("./clientHooks.cjs");
exports.PrismicProvider = PrismicProvider.PrismicProvider;
exports.usePrismicContext = usePrismicContext.usePrismicContext;
exports.usePrismicClient = usePrismicClient.usePrismicClient;
exports.PrismicLink = PrismicLink.PrismicLink;
exports.PrismicText = PrismicText.PrismicText;
exports.PrismicRichText = PrismicRichText.PrismicRichText;
Object.defineProperty(exports, "Element", {
  enumerable: true,
  get: () => prismicR.Element
});
exports.PrismicImage = PrismicImage.PrismicImage;
exports.SliceZone = SliceZone.SliceZone;
exports.TODOSliceComponent = SliceZone.TODOSliceComponent;
exports.PrismicToolbar = PrismicToolbar.PrismicToolbar;
exports.usePrismicPreviewResolver = usePrismicPreviewResolver.usePrismicPreviewResolver;
exports.useAllPrismicDocumentsByEveryTag = clientHooks.useAllPrismicDocumentsByEveryTag;
exports.useAllPrismicDocumentsByIDs = clientHooks.useAllPrismicDocumentsByIDs;
exports.useAllPrismicDocumentsBySomeTags = clientHooks.useAllPrismicDocumentsBySomeTags;
exports.useAllPrismicDocumentsByTag = clientHooks.useAllPrismicDocumentsByTag;
exports.useAllPrismicDocumentsByType = clientHooks.useAllPrismicDocumentsByType;
exports.useAllPrismicDocumentsByUIDs = clientHooks.useAllPrismicDocumentsByUIDs;
exports.useAllPrismicDocumentsDangerously = clientHooks.useAllPrismicDocumentsDangerously;
exports.useFirstPrismicDocument = clientHooks.useFirstPrismicDocument;
exports.usePrismicDocumentByID = clientHooks.usePrismicDocumentByID;
exports.usePrismicDocumentByUID = clientHooks.usePrismicDocumentByUID;
exports.usePrismicDocuments = clientHooks.usePrismicDocuments;
exports.usePrismicDocumentsByEveryTag = clientHooks.usePrismicDocumentsByEveryTag;
exports.usePrismicDocumentsByIDs = clientHooks.usePrismicDocumentsByIDs;
exports.usePrismicDocumentsBySomeTags = clientHooks.usePrismicDocumentsBySomeTags;
exports.usePrismicDocumentsByTag = clientHooks.usePrismicDocumentsByTag;
exports.usePrismicDocumentsByType = clientHooks.usePrismicDocumentsByType;
exports.usePrismicDocumentsByUIDs = clientHooks.usePrismicDocumentsByUIDs;
exports.useSinglePrismicDocument = clientHooks.useSinglePrismicDocument;
//# sourceMappingURL=index.cjs.map
